export enum Module {
  Lashing = 'lashing',
  Stowage = 'stowage',
  Barging = 'barging',
  Offshore = 'offshore',
  Lifting = 'lifting',
  Deckstrength = 'deckstrength',
  RoadTransport = 'road-transport',
  Mooring = 'mooring',
  RoRo = 'roro',
  Reporting = 'reporting',
  SuperAdmin = 'super-admin',
  ApplicationManager = 'application-manager',
  CargoLoader = 'cargo-loader',
}

export const ModuleLabels: Record<Module, string> = {
  [Module.Lashing]: 'Lashing + Securing',
  [Module.Stowage]: 'Stowage Planning',
  [Module.Barging]: 'Barging',
  [Module.Offshore]: 'Offshore',
  [Module.Lifting]: 'Lifting',
  [Module.Deckstrength]: 'Deckstrength',
  [Module.RoadTransport]: 'Road transport',
  [Module.Mooring]: 'Mooring',
  [Module.RoRo]: 'RoRo',
  [Module.Reporting]: 'Reporting',
  [Module.SuperAdmin]: 'Super admin',
  [Module.ApplicationManager]: 'Application manager',
  [Module.CargoLoader]: 'Cargo loader',
};
